export const GOOGLE_PLAY_PACKAGE_ID = 'com.ahmedaher.ibnsirin';

export const PLAY_STORE_BASE_URL = 'https://play.google.com/store/apps/details?id=' + GOOGLE_PLAY_PACKAGE_ID;

export const UTM_SOURCE = 'ibn_sirin_web';
export const UTM_MEDIUM = 'organic';
export const UTM_CAMPAIGN = 'app_download';

export type AppCtaContent =
  | 'home_hero'
  | 'home_section'
  | 'home_final'
  | 'home_footer'
  | 'nav_app'
  | 'dream_symbol'
  | 'dream_bottom'
  | 'app_page'
  | 'ai_result'
  | 'mobile_sticky';

export function playStoreUrl(content: AppCtaContent): string {
  return `${PLAY_STORE_BASE_URL}&utm_source=${UTM_SOURCE}&utm_medium=${UTM_MEDIUM}&utm_campaign=${UTM_CAMPAIGN}&utm_content=${content}`;
}